import {
  faPlus,
  faTrash,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { useAppContext } from "../../../AppProvider";
import { useIndexArticlesContext } from "../providers/Index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useTypes } from "../../../utilities/types";
import { getAllArticlesCompanies } from "../../../Components/Selects/AsyncSelect/api";
import { getCompanyOptionStyle } from "../../../Components/Selects/AsyncSelect/styles";

export const isDisabledDelete = (selectedRows) => {
  const { accessTokenPayload } = useAppContext();

  return !selectedRows.every(
    (item) => item.ownerId === accessTokenPayload.owner
  );
};

export const useListProps = () => {
  const navigate = useNavigate();

  const { dictionary } = useAppContext();
  const { confirmationBoolOptions } = useTypes();

  const context = useIndexArticlesContext();

  return {
    path: `/logistic-service/articles`,
    banner: {
      enabled: true,
    },
    pagination: { enabled: true },
    title: dictionary.products.products,
    omnisearch: {
      enabled: true,
      placeholder: `${dictionary.registries.name}, ${dictionary.references.external_reference}, ${dictionary.products.barcode}`,
    },
    create: {
      enabled: true,
      action: () => {
        navigate("/articles/create");
      },
      title: `${
        dictionary.actions.add
      } ${dictionary.products.product.toLowerCase()}`,
      icon: faPlus,
    },
    selectRowsEnabled: { enabled: true },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          context.setModalConfig({
            isOpen: true,
            title: dictionary.actions.delete_selected,
            action: "delete",
            data: selectedRows.map((item) => item.id),
          }),
        label: dictionary.actions.delete_selected,
        icon: <FontAwesomeIcon icon={faTrash} />,
        className: "button-1 button-1-danger",
        isDisabled: isDisabledDelete,
      },
    ],
    filters: {
      name: "articles",
      preserve: true,
      list: [
        {
          fieldName: "ownerId",
          label: dictionary.registries.customer,
          type: "async-select",
          loadOptions: getAllArticlesCompanies,
          isMulti: true,
          optionStyle: (option) => {
            const CompanyOption = getCompanyOptionStyle(option);
            return <CompanyOption />;
          },
          primary: true,
          col: 3,
        },
        {
          fieldName: "pub",
          label: dictionary.words.public,
          type: "select",
          primary: true,
          options: confirmationBoolOptions,
          col: 2,
        },
        {
          fieldName: "uniqueBarcodeItem",
          label: dictionary.products.unique_barcode,
          type: "select",
          primary: true,
          options: confirmationBoolOptions,
          col: 2,
        },
        {
          fieldName: "shippingRequired",
          label: dictionary.products.physical_good,
          type: "select",
          primary: true,
          options: confirmationBoolOptions,
          col: 2,
        },
      ],
    },
  };
};
